export const calculateTalentNetPay = ({
    amount,
    skillGigPercentage,
    payrollCostPercentage,
  }) => {
    const skillGiggFee = amount * (skillGigPercentage/100);
    const grossPay = amount - skillGiggFee;
    const payrollCost = grossPay * (payrollCostPercentage/100);
    const netGrossPay = grossPay - payrollCost;
  
    return { skillGiggFee, grossPay, payrollCost, netGrossPay };
  };
  